













import Vue from 'vue';
import Component from 'vue-class-component';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';

const RelaunchButton = () => import('@/common/vue/RelaunchButton');

const ParagraphButtonProps = Vue.extend({
  props: {
    buttonColor: String,
    linkText: String,
    externalLink: String,
    internalLink: String,
    downloadLink: String,
    linkTarget: String,
    editMode: Boolean,
  },
});

@Component({
  components: {
    RelaunchButton,
  },
})
export default class ParagraphButton extends ParagraphButtonProps {
  get link () {
    return this.externalLink || this.internalLink || this.downloadLink;
  }

  trackLink () {
    TrackingPushService.getInstance().pushTrackingAttributes(
      'link',
      'paragraph button',
      this.linkText,
      this.link,
    );
  }
}
